export const types = {
  STEP_TARGET_REQUESTS: 'stepTargetRequests'
};
